import { NewsArticle, WithContext } from 'schema-dts';

export type CreateNewsArticleInput = {
  title: string | null;
  url: string;
  imageUrl: string;
  publishedDate: string;
  modifiedDate: string;
  author: { name: string };
  description: string;
};

export const createNewsArticleMicroData = (
  input: CreateNewsArticleInput
): WithContext<NewsArticle> => {
  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': input.url,
    },
    image: [input.imageUrl],
    datePublished: input.publishedDate,
    dateModified: input.modifiedDate,
    author: {
      '@type': 'Person',
      name: input.author.name,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Techarenan', // TODO: DO NOT HARDCODE. Read from WordPress
      logo: {
        '@type': 'ImageObject',
        url: '', // TODO: Add logo url here. Maybe a static file from /static?
      },
    },
    description: input.description,
  };
};
